export default "__VITE_ASSET__957b75ea__"